import { Formik, FormikActions, FormikProps } from 'formik';
import * as React from 'react';
import * as Yup from 'yup';

import API from 'src/services/api';
import { FormInput, Button } from 'src/components';

interface IFormFields {
  email: string;
}
interface IPasswordResetState {
  error: string;
  requestSent: boolean;
}

export default class PasswordReset extends React.Component<
  {},
  IPasswordResetState
> {
  state: IPasswordResetState = {
    error: '',
    requestSent: false,
  };

  schema = Yup.object().shape({
    email: Yup.string().email().required('Required'),
  });

  initialValues: IFormFields = { email: '' };

  onSubmit = async (
    values: IFormFields,
    actions: FormikActions<IFormFields>
  ) => {
    this.setState({ error: '' });
    try {
      await API.USER.PASSWORD_CHANGE.request(values.email);
      this.setState({ requestSent: true });
    } catch (error) {
      const message = error.response.data.errorMessage;
      this.setState({
        error: message === 'invalid_user' ? 'Invalid user' : message,
      });
    }
    actions.setSubmitting(false);
  };

  formRender = ({
    errors,
    touched,
    handleSubmit,
    isSubmitting,
  }: FormikProps<IFormFields>) => (
    <form onSubmit={handleSubmit}>
      <div className="flex items-center my-6">
        <label className="w-32 text-right pr-6" htmlFor="username">
          Email
          {errors.email && touched.email ? (
            <span className="block text-sm text-red">{errors.email}</span>
          ) : null}
        </label>
        <FormInput
          className="flex-1"
          name="email"
          autoFocus={true}
          secondary={true}
        />
      </div>
      <div className="flex items-center ml-32">
        <Button type="submit" loading={isSubmitting} loadingLabel="Sending">
          Send
        </Button>
        {this.state.error && (
          <span className="flex-1 ml-4 text-red">{this.state.error}</span>
        )}
      </div>
    </form>
  );

  render() {
    return (
      <div className="w-1/2 my-32 mx-auto text-xl">
        <h2 className="ml-32 mb-8">Reset password</h2>
        {this.state.requestSent ? (
          <>
            <p className="ml-32 mb-4">
              <em className="text-green">Request sent.</em>
            </p>
            <p className="ml-32">
              You will receive an email with a password recovery link.
            </p>
          </>
        ) : (
          <Formik
            initialValues={this.initialValues}
            validationSchema={this.schema}
            onSubmit={this.onSubmit}
            render={this.formRender}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PasswordReset/PasswordReset.tsx